import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import InfoIcon from '../icons/InfoIcon';
import Popover from '../popovers/Popover';

const TileLayout = styled.div`
  position: relative;

  // Needs to inherit width
  // to work with masonry layout.
  width: inherit;

  min-height: 7.5625rem;
  height: 100%;
  padding: 0.8rem 0 0 0;
  background: #fff;
  box-shadow: rgba(173, 173, 173, 0.2) 0px 1px 1px 1px;
`;

const PopoverWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const PopoverContainer = styled.div`
  width: 29.125rem;
  margin-left: 95%;
`;

interface Props {
  children: ReactNode;
  showPopover?: boolean;
  popoverText?: ReactNode;
}

export const Tile = (props: Props) => {
  const { showPopover, popoverText, children } = props;
  return (
    <TileLayout>
      {showPopover && (
        <PopoverWrapper>
          <PopoverContainer>
            <Popover content={popoverText}>
              <InfoIcon preserveAspectRatio="xMinYMin" height="24" />
            </Popover>
          </PopoverContainer>
        </PopoverWrapper>
      )}
      {children}
    </TileLayout>
  );
};

export default Tile;
